// ============================================================================
// schedule-signature.ts — Helpers partagés « signature de planning mensuel ».
// ----------------------------------------------------------------------------
// Règle métier : le salarié signe le planning d'un mois. La fenêtre de signature
// va du 28 du mois au 5 du mois suivant. Le « mois à signer » à une date donnée :
//   - jour ≥ 28  → le mois courant (il se termine, on le signe)
//   - jour <  28 → le mois précédent (fenêtre du 1er au 5, ou rappel en retard)
// → une seule règle : day >= 28 ? mois courant : mois précédent.
// ============================================================================

/** Clé DB d'un mois : 1er jour au format ISO 'YYYY-MM-01'. */
export function monthKey(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
}

/** Mois que le salarié doit signer à la date `now` (1er jour du mois). */
export function targetSignMonth(now: Date = new Date()): Date {
  const day = now.getDate();
  const y = now.getFullYear();
  const m = now.getMonth();
  // day >= 28 → mois courant ; sinon mois précédent.
  return day >= 28 ? new Date(y, m, 1) : new Date(y, m - 1, 1);
}

/** Vrai si on est dans la fenêtre active de signature (28 du mois → 5 du suivant). */
export function isInSigningWindow(now: Date = new Date()): boolean {
  const day = now.getDate();
  return day >= 28 || day <= 5;
}

/** Libellé « juillet 2026 » d'un mois. */
export function monthLabel(d: Date): string {
  return d.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
}

/** Bornes ISO [premier, dernier] jour d'un mois (1er jour donné). */
export function monthBounds(firstDay: Date): { from: string; to: string } {
  const y = firstDay.getFullYear();
  const m = firstDay.getMonth();
  const first = new Date(y, m, 1);
  const last = new Date(y, m + 1, 0);
  const iso = (x: Date) => `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}-${String(x.getDate()).padStart(2, '0')}`;
  return { from: iso(first), to: iso(last) };
}
